import React, { useState } from 'react';
import { Typography } from '../../../_shared/components/Typography/Typography';
import { Card } from '../../../_shared/components/Card/Card';
import { StatusLabel } from '../../../_shared/components/StatusLabel/StatusLabel';
import { ReactComponent as PlusIcon } from '../../../_shared/assets/icons/plus.svg';
import { KpiFormModal } from '../../../_shared/components/KpiFormModal/KpiFormModal';
import { KpiTable } from '../../../_shared/components/KpiTable/KpiTable';
import { mockKpiItems } from '../../../_shared/mocks';
import { Button } from '../../../_shared/components/Button/Button';
import { Accordion } from '../../../_shared/components/Accordion/Accordion';
import styles from './WorkersList.module.scss';

export function WorkersList({ workers }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <div className={styles.container}>
      {workers.map((worker, index) => (
        <Accordion
          key={worker.id || index}
          header={
            <div className={styles.workerHeader}>
              <div className={styles.text}>
                <Typography variant="h3">{worker.userName}</Typography>
                <Typography variant="text">{worker.JobTitle}</Typography>
              </div>
              <StatusLabel
                variant={
                  worker.status === 'success'
                    ? 'success'
                    : worker.status === 'error'
                    ? 'error'
                    : 'info'
                }
              >
                {worker.statusName}
              </StatusLabel>
            </div>
          }
        >
          <Card>
            <KpiTable
              rows={mockKpiItems}
              editable
              onKpiClick={(row) => console.log('kpi click', row)}
              onEdit={(row) => console.log('edit', row)}
              onDelete={(row) => console.log('delete', row)}
            />
            <div className={styles.actions}>
              <Button
                variant="secondary"
                onClick={() => setIsModalOpen(true)}
                className={styles.button}
              >
                Добавить KPI <PlusIcon />
              </Button>
              <Button
                variant="primary"
                onClick={() => alert('КПЭ согласованы')}
                className={styles.button}
              >
                КПЭ согласованы
              </Button>
            </div>
          </Card>
        </Accordion>
      ))}
      <KpiFormModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={(values) => console.log('submit', values)}
        notification={'Текст возможного уведомления'}
      />
    </div>
  );
}
